var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 444,
    viewBox: "0 0 461 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.692 443.727C198.324 443.727 167.538 438.134 139.334 426.947C111.528 415.761 87.0976 400.18 66.044 380.205C45.3877 360.23 29.2996 336.659 17.7797 309.492C6.25983 282.326 0.5 252.962 0.5 221.401C0.5 189.44 6.06124 160.076 17.1839 133.309C28.7037 106.542 44.7919 83.1712 65.4482 63.1958C86.1045 43.2205 110.336 27.8394 138.142 17.0527C166.346 5.86653 197.132 0.273438 230.5 0.273438C263.868 0.273438 294.455 5.86653 322.262 17.0527C350.466 27.8394 374.895 43.2205 395.552 63.1958C416.208 83.1712 432.098 106.742 443.22 133.909C454.74 160.676 460.5 190.039 460.5 222C460.5 253.561 454.74 282.925 443.22 310.091C434.983 329.915 424.131 347.985 410.665 364.302H460.5V443.727H231.692ZM232.155 79.6979C232.155 158.289 165.481 222 83.2338 222C165.481 222 232.155 285.711 232.155 364.302C232.155 285.711 298.829 222 381.076 222C298.829 222 232.155 158.289 232.155 79.6979Z",
    fill: "#043F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoMark);
export default __webpack_public_path__ + "static/media/ic-logo-mark.37b83057dfd9e639db7833ea7ff05c79.svg";
export { ForwardRef as ReactComponent };